import SchedulePanel from './SchedulePanel';

export default SchedulePanel;
